export default "__VITE_ASSET__DgUMdxAf__"